import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';

@Component({
  selector:'app-payment-checkout',
  templateUrl:'./payment-checkout.component.html',
  styleUrls:['./payment-checkout.component.scss']
})
export class PaymentCheckoutComponent implements OnInit{

  bookingData:any;

  paymentType:any;

  constructor(
    private router:Router,
    private apiService:ApiServiceService
  ){}

  ngOnInit(){

    const navigation = this.router.getCurrentNavigation();

    const state = navigation?.extras.state;

    if(state){

      this.bookingData = state['bookingData'];

    }
    else{

      const data = sessionStorage.getItem('pendingBooking');

      if(data){

        this.bookingData = JSON.parse(data);

      }

    }

    console.log("CHECKOUT DATA",this.bookingData);

    this.paymentType = this.bookingData?.payment?.type;

  }

  // ----------------------------
  // FULL PAYMENT
  // ----------------------------

  payFullPayment(){


const orderPayload = {

amount:this.bookingData.price,

currency:"INR",

receipt:
"booking_"+Date.now()

};



this.apiService
.createMerchantPaymentOrder(orderPayload)
.subscribe({

next:(res:any)=>{


console.log(
"RAZORPAY ORDER",
res
);



this.openRazorpay(
res.data
);



},


error:(err)=>{


console.log(
"ORDER ERROR",
err
);


}


});


}

  // ----------------------------
  // ADVANCE PAYMENT
  // ----------------------------

  payAdvance(){


const advanceAmount =
this.bookingData.payment?.advanceAmount;


const orderPayload = {


amount: advanceAmount,


currency:"INR",


receipt:
"advance_booking_"+Date.now()


};



this.apiService
.createMerchantPaymentOrder(orderPayload)
.subscribe({

next:(res:any)=>{


console.log(
"ADVANCE RAZORPAY ORDER",
res
);



this.openAdvanceRazorpay(
res.data
);



},


error:(err)=>{


console.log(
"ADVANCE ORDER ERROR",
err
);


}


});


}

  // ----------------------------
  // POSTPAID
  // ----------------------------

  confirmPostpaid(){

    this.createBooking("Pending");

  }

  // ----------------------------
  // CASH ON HAND
  // ----------------------------

  confirmCashOnHand(){

    this.createBooking("Pending");

  }

  // ----------------------------
  // CREATE BOOKING
  // ----------------------------

  createBooking(paymentStatus:string){


let bookingStatus = "Confirmed";



const bookingPayload = {


serviceId:this.bookingData.serviceId,


merchantId:this.bookingData.merchantId,


service_name:this.bookingData.service_name,


category:
this.bookingData.category?.name ||
this.bookingData.category,


price:this.bookingData.price,


selectedDate:this.bookingData.selectedDate,


customer_name:this.bookingData.customer_name,


customer_phone:this.bookingData.customer_phone,


customer_email:this.bookingData.customer_email,


function_name:this.bookingData.function_name,


location:this.bookingData.location,


additional_details:
this.bookingData.additional_details,



payment_status:paymentStatus,


booking_status:bookingStatus


};



console.log(
"CREATE BOOKING DATA",
bookingPayload
);



this.apiService
.createBooking(bookingPayload)
.subscribe({

next:(res:any)=>{


console.log(
"BOOKING CREATED",
res
);



const bookingId =
res.data._id;



this.createPayment(
bookingId,
paymentStatus
);



},


error:(err)=>{


console.log(
"BOOKING ERROR",
err
);


}


});


}
createPayment(
bookingId:any,
paymentStatus:string
){


const paymentPayload = {


bookingId:bookingId,


merchantId:
this.bookingData.merchantId,


customer_email:
this.bookingData.customer_email,


service_name:
this.bookingData.service_name,


total_amount:
this.bookingData.price,


payment_type:
this.paymentType === 'FULL_PAYMENT'
? 'Full Payment'
:
this.paymentType === 'ADVANCE'
? 'Advance'
:
this.paymentType === 'POSTPAID'
? 'Postpaid'
:
'Cash On Hand',


advance_amount:
this.bookingData.payment?.advanceAmount || 0,


remaining_amount:
this.paymentType === 'FULL_PAYMENT'
?
0
:
this.bookingData.price -
(this.bookingData.payment?.advanceAmount || 0),



payment_status: paymentStatus


};



console.log(
"CREATE PAYMENT DATA",
paymentPayload
);



this.apiService
.createMerchantPayment(paymentPayload)
.subscribe({

next:(res)=>{


console.log(
"PAYMENT CREATED",
res
);


alert(
"Booking completed successfully"
);



},


error:(err)=>{


console.log(
"PAYMENT ERROR",
err
);


}


});


}
openRazorpay(order:any){


const options:any = {


key:
order.key,


amount:
order.amount,


currency:
order.currency,


name:
"Weddingly",


description:
this.bookingData.service_name,


order_id:
order.orderId,



handler:(response:any)=>{


console.log(
"RAZORPAY SUCCESS",
response
);



alert(
"Payment Successful"
);



if(this.paymentType === 'Advance'){

    this.createBooking("Advance Paid");

}
else{

    this.createBooking("Paid");

}



},



prefill:{


name:
this.bookingData.customer_name,


email:
this.bookingData.customer_email,


contact:
this.bookingData.customer_phone


},



theme:{


color:"#800020"


}



};



if((window as any).Razorpay){

const razorpay =
new (window as any).Razorpay(options);

razorpay.open();

}
else{

console.log(
"Razorpay SDK not loaded"
);

alert(
"Payment gateway loading failed"
);

}


}
openAdvanceRazorpay(order:any){


const options:any = {


key:
order.key,


amount:
order.amount,


currency:
order.currency,


name:
"Weddingly",


description:
"Advance Payment - "+this.bookingData.service_name,


order_id:
order.orderId,



handler:(response:any)=>{


console.log(
"ADVANCE PAYMENT SUCCESS",
response
);



alert(
"Advance Payment Successful"
);



this.createBooking("Advance Paid");



},



prefill:{


name:
this.bookingData.customer_name,


email:
this.bookingData.customer_email,


contact:
this.bookingData.customer_phone


},



theme:{


color:"#800020"


}



};



const razorpay =
new (window as any).Razorpay(options);


razorpay.open();



}
}